export const CC_DECLINE_RATE = 70;

/**
 * 5281 is the generic error code that paysafejs gives us
 * when tokenization fails for a card that our paysafe account
 * is not configured to handle. This could be for a card that we
 * don't support (Amex), or a type we don't support (debit only).
 * Until we get specific error codes for why the tokenization
 * failed, we have to be generic with our errors.
 */
export const codes = {
  NOT_SUPPORTED: '5281',
};

export const errorMessageByCode = {
  [codes.NOT_SUPPORTED]:
    'There was an error (5281), please contact our support.',
};

export const cardNumberFieldErrorIds = {
  DECLINE_RATE: 'declineRate',
  SUBMIT_FAIL: 'submitFail',
};

export const getCardNumberFieldErrors = ({ code } = {}) => ({
  [cardNumberFieldErrorIds.DECLINE_RATE]: {
    errorSlotId: 'declineRateError',
    message:
      'This card might have a low approval rate, an alternate card is recommended.',
  },
  [cardNumberFieldErrorIds.SUBMIT_FAIL]: {
    errorSlotId: 'submitFailError',
    message: code ? errorMessageByCode[code] : null,
  },
});

export const errorColor = 'rgb(240, 76, 39)';
